<template>
  <search-options class="navbar-item is-marginless search-nav"
                  :placeholder="$t('searchPlaceholder')"
                  :value="input"
                  :exact-match="isExactMatch"
                  @enter="search"
                  @searchContent="searchContentType"
                  @updateInputWithoutSearch="updateInput"
                  @toggleExactMatch="updateExactMatch(!isExactMatch)"
  />
</template>

<script setup>
  import { useSearch } from '@/components/widgets/composables/useSearch'
  import SearchOptions from '@/components/common/search/SearchOptions'

  const emit = defineEmits(['updateExactMatch', 'updateInput'])
  const props = defineProps({
    input: {
      type: String,
      required: true
    },
    isExactMatch: {
      type: String,
      required: false
    }
  })

  const {
    navigateToSearch,
  } = useSearch()

  const updateInput = (value) => {
    emit('updateInput', value)
  }

  const searchContentType = (value, input, mediaCatId) => {
    navigateToSearch(
      input,
      { clearAllContent: true },
      value,
      mediaCatId
    )
  }

  const search = (value) => {
    updateInput(value)
    navigateToSearch(
      value,
      { clearAllContent: true }
    )
  }

  const updateExactMatch = (value) => {
    emit('updateExactMatch', value)
    localStorage.setItem("defaultSearchMode", value ? 'exact' : 'contains')
  }

</script>

<style lang="scss" scoped>
.search-nav {
  min-width: 50%;
  @media screen and (max-width: 640px) {
    padding-bottom: 1rem;
  }
}
</style>
